import React, { useState } from 'react';
import './Carousel.css';

const Carousel = ({ imagenes = [], altura = "220px", className = "", showWelcomeText = false }) => {
  const [indiceActual, setIndiceActual] = useState(0);

  // Si no hay imágenes, mostrar un placeholder
  if (!imagenes.length) {
    return (
      <div 
        className={`carousel-container ${className}`}
        style={{ height: altura }}
      >
        <div className="imagen-placeholder">No hay imágenes disponibles</div>
      </div>
    );
  }

  const irAAnterior = (e) => {
    e.stopPropagation(); // Evitar que el clic se propague al contenedor de habitación
    setIndiceActual(indice => (indice === 0 ? imagenes.length - 1 : indice - 1));
  };

  const irASiguiente = (e) => {
    e.stopPropagation(); // Evitar que el clic se propague al contenedor de habitación
    setIndiceActual(indice => (indice === imagenes.length - 1 ? 0 : indice + 1));
  };

  const irAIndice = (indice, e) => {
    e.stopPropagation(); // Evitar que el clic se propague al contenedor de habitación
    setIndiceActual(indice);
  };

  return (
    <div 
      className={`carousel-container ${className}`}
      style={{ height: altura }}
    >
      <div className="carousel-imagenes">
        {imagenes.map((imagen, indice) => (
          <div 
            key={indice} 
            className={`carousel-slide ${indice === indiceActual ? 'active' : ''}`}
          >
            <img src={imagen} alt={`Imagen ${indice + 1}`} />
            {showWelcomeText && indice === 0 && (
              <div className="carousel-welcome-text">
                <h2>Bienvenidos a nuestro hospedaje</h2>
              </div>
            )}
          </div>
        ))}
      </div>
      
      {imagenes.length > 1 && (
        <>
          <button 
            className="carousel-control carousel-prev" 
            onClick={irAAnterior}
            aria-label="Imagen anterior"
          >
            &#10094;
          </button>
          
          <button 
            className="carousel-control carousel-next" 
            onClick={irASiguiente}
            aria-label="Imagen siguiente"
          >
            &#10095;
          </button>
          
          <div className="carousel-indicadores">
            {imagenes.map((_, indice) => (
              <button
                key={indice}
                className={`indicador ${indice === indiceActual ? 'active' : ''}`}
                onClick={(e) => irAIndice(indice, e)}
                aria-label={`Ir a imagen ${indice + 1}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Carousel; 